import { createFileRoute } from "@tanstack/react-router";
import { ConclusionView } from "@/components/Exercises/PersonalSources/ConclusionView.tsx";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/personal-sources/end"
)({
  component: () => <ConclusionView audience="children" />,
  head: () => ({
    meta: [
      {
        title: "Personal Sources of Strength - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "personalSources.title",
    navbar: {
      showTitle: true,
    },
  }),
});
